import { z } from "zod"
import { LessonAbsenceReasonMap } from "./calendar"

export const changeTypeEnum = z.enum(
  ["group_removal", "permanent_stop", "switch_group"],
  {
    message: "Selecteer een soort wijziging",
  },
)

export type ChangeType = z.infer<typeof changeTypeEnum>

export const changeTypeOptions: { value: ChangeType; label: string }[] = [
  { value: "group_removal", label: "Tijdelijk geen les" },
  { value: "permanent_stop", label: "Permanent stoppen" },
  { value: "switch_group", label: "Wisselen van groep" },
]

export const droppedOutReasonEnum = z.enum(
  [
    "relocation",
    "learning_route_other_provider",
    "learning_route_change",
    "illness",
    "other",
  ],
  { message: "Selecteer een reden" },
)

export type DroppedOutReason = z.infer<typeof droppedOutReasonEnum>

export const droppedOutReasonOptions: {
  value: DroppedOutReason
  label: string
}[] = [
  { value: "relocation", label: "Verhuizing" },
  {
    value: "learning_route_other_provider",
    label: "Leerroute andere aanbieder",
  },
  { value: "learning_route_change", label: "Wijziging leerroute" },
  { value: "illness", label: "Ziekte" },
  { value: "other", label: "Overig" },
]

export const droppedOutReasonMap: Record<DroppedOutReason, string> = {
  relocation: "Verhuizing",
  learning_route_other_provider: "Leerroute andere aanbieder",
  learning_route_change: "Wijziging leerroute",
  illness: "Ziekte",
  other: "Overig",
}

export const interruptedReasonEnum = z.enum(
  [
    "suspended_behavior",
    "suspended_high_absence",
    "illness_pregnancy",
    "no_suitable_group",
    "other",
  ],
  { message: "Selecteer een reden" },
)

export type InterruptedReason = z.infer<typeof interruptedReasonEnum>

export const interruptedReasonOptions: {
  value: InterruptedReason
  label: string
}[] = [
  { value: "suspended_behavior", label: "Schorsing gedrag" },
  { value: "suspended_high_absence", label: "Schorsing hoog verzuim" },
  { value: "illness_pregnancy", label: "Ziekte/zwangerschap" },
  { value: "no_suitable_group", label: "Geen passende groep" },
  { value: "other", label: "Overig" },
]

export const interruptedReasonMap: Record<InterruptedReason, string> = {
  suspended_behavior: "Schorsing gedrag",
  suspended_high_absence: "Schorsing hoog verzuim",
  illness_pregnancy: "Ziekte/zwangerschap",
  no_suitable_group: "Geen passende groep",
  other: "Overig",
}

export const allInterruptionReasons: { value: string; label: string }[] = [
  ...Object.entries(interruptedReasonMap).map(([value, label]) => ({
    value,
    label,
  })),
  ...Object.entries(LessonAbsenceReasonMap).map(([value, label]) => ({
    value,
    label,
  })),
]
